import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const brokeredOrderLinkOrdersAtom = createMutationAtomFactory(
  'brokerage.brokeredOrderLinkOrders',
  (params: {
    id: string;
    addPurchaseOrderIds?: string[];
    removePurchaseOrderIds?: string[];
    addSalesOrderIds?: string[];
    removeSalesOrderIds?: string[];
  }) => ({
    tradeBrokeredOrderLinkOrders: {
      __args: {
        id: params.id,
        input: {
          addPurchaseOrderIds: params.addPurchaseOrderIds,
          removePurchaseOrderIds: params.removePurchaseOrderIds,
          addSalesOrderIds: params.addSalesOrderIds,
          removeSalesOrderIds: params.removeSalesOrderIds,
        },
      },
      id: true,
      purchaseOrders: {
        id: true,
        documentNumber: true,
      },
      salesOrders: {
        id: true,
        documentNumber: true,
      },
      purchaseTotal: {
        amount: true,
        currencyCode: true,
      },
      salesTotal: {
        amount: true,
        currencyCode: true,
      },
      margin: {
        amount: true,
        currencyCode: true,
      },
      marginPercent: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
